import { useState, useEffect } from 'react';

function isMobileDevice(): boolean {
  return /Android|iPhone|iPod/i.test(navigator.userAgent);
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

  useEffect(() => {
    const check = () => setIsMobile(isMobileDevice() || window.innerWidth < 768);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return isMobile;
}
